import React from 'react';
import _ from 'lodash';
import '../css/common.css';
import '../css/shop_list_list_item.css';

function FormatDate(jDate) {
    var d = new Date(jDate);
    return d.toLocaleDateString();
}

function BuildRepeater(inList)
{
  var rList = '';
  _.map(inList, listItem => {
    rList = rList + listItem + ', ';
    }
  )
  return rList.replace(/,\s*$/, "")
}

function BuildExtras(inList)
{
  return inList.replace(/\r\n/g, ", ")
}

const ShopListListItem = ({shopList, onShopListSelect, evenrow}) => {
  return (
    <li onClick={() => onShopListSelect(shopList)} className={evenrow ? 'ultra-light-b main-font list-even' : 'main-font'}>
      <div id="divSLLMainArea">
        <div id="divSLLLine1" className="divSLLLine">
          <div className="divSLLNameArea divSLLNameTxt">
            {shopList.Name}
          </div>
          <div className="blue-font bold divSLLDetailsLbl">
            Recipes
          </div>
          <div className="divSLLDetailsTxt" title={BuildRepeater(shopList.RecipeNames)}>{BuildRepeater(shopList.RecipeNames)}</div>
        </div>
        <div id="divSLLLine2" className="divSLLLine">
          <div className="divSLLNameArea divSLLListDT">
            {FormatDate(shopList.Shop_Time)}
          </div>
          <div className="blue-font bold divSLLDetailsLbl">
            Extras
          </div>
          <div className="divSLLDetailsTxt" title={BuildExtras(shopList.Notes)}>{BuildExtras(shopList.Notes)}</div>
        </div>
      </div>
    </li>
  );
};

export default ShopListListItem;



// WEBPACK FOOTER //
// ./src/components/shop_list_list_item.js